import { Subject } from "@carnegie-learning/cure-types";
import { FeathersServicePagination } from "@carnegie-learning/data-access-core";
import { createAction, props } from "@ngrx/store";

export const LOAD_STUDENT_ACTIVESUBJECTS = "[Student Courses] Load Active Subjects";
export const LOAD_STUDENT_ACTIVESUBJECTS_FAIL = "[Student Courses] Load Active Subjects Fail";
export const LOAD_STUDENT_ACTIVESUBJECTS_SUCCESS =
    "[Student Courses] Load Active Subjects Success";

export const LoadStudentActiveSubjects = createAction(LOAD_STUDENT_ACTIVESUBJECTS);

export const LoadStudentActiveSubjectsFail = createAction(
    LOAD_STUDENT_ACTIVESUBJECTS_FAIL,
    props<{
        payload: any
    }>()
);

export const LoadStudentActiveSubjectsSuccess = createAction(
    LOAD_STUDENT_ACTIVESUBJECTS_SUCCESS,
    props<{
        payload: FeathersServicePagination<Subject>
    }>()
);
